import script from "./enarticle.vue?vue&type=script&setup=true&lang=js"
export * from "./enarticle.vue?vue&type=script&setup=true&lang=js"

import "./enarticle.vue?vue&type=style&index=0&id=8080f0f0&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8080f0f0"]])

export default __exports__